<template>
  <WsMain>
    <WsCRUD
      orderWay="asc"
      orderBy="sequence"
      :label="label"
      :fields="fields"
      :modelName="modelName"
      :showFields="showFields"
      :inRowBtnRead="false"
      :customCreateAction="$_setSubmit"
      :customUpdateAction="$_setSubmit"
      :submitErrorHandler="$_submitErrorHandler"
    />
  </WsMain>
</template>

<script>
import model from '@/models/modulePage';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: ['name', 'module', 'value', 'updated_at', 'updated_admin'],
    };
  },
  methods: {
    $_setSubmit(modelData) {
      modelData.pattern = JSON.parse(modelData.pattern);
      modelData.app_params = JSON.parse(modelData.app_params);
      return modelData;
    },
    $_submitErrorHandler(error) {
      if (error.message.includes('JSON')) {
        alert('pattern 或 app_params 格式錯誤');
      } else if(error.message) alert(error.message);
      else alert('新增失敗');
    }
  },
};
</script>